import { render, staticRenderFns } from "./EvrakIndirFormWizard.vue?vue&type=template&id=1dc7bf70"
import script from "./EvrakIndirFormWizard.vue?vue&type=script&lang=ts"
export * from "./EvrakIndirFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports